import { StandardRequest, StandardResponse } from "./functions";

/**
 * Categorized violation types for prohibited media content.
 */
export type SafetyCategory =
  | "pornography"
  | "violence"
  | "discriminatory"
  | "malware"
  | "invalid_format";

/**
 * Result returned by the content safety and moderation scanner.
 */
export interface IContentSafetyScanResult {
  safe: boolean;
  category?: SafetyCategory;
  reason?: string;
}

/**
 * Request payload for scanning media or text content.
 */
export interface IScanMediaContentRequest extends StandardRequest {
  base64?: string;
  fileName?: string;
  text?: string;
  contentType?: string;
}

/**
 * Response payload after scanning media or text content.
 */
export interface IScanMediaContentResponse extends StandardResponse {
  scanResult: IContentSafetyScanResult;
}
